import { Fragment } from 'react';
import { Constants } from './Constants';
import { getSearchFromQuery } from './PaginationUtil';
export const getScriptForLanguage = (lang, isIxnquery, isStagingEnv) => {
  // const scriptConfig = {
  //   nl: {
  //     domainScript: '549d5d3f-f431-4a46-ab40-7c3e8f334715',
  //   },
  //   'en-gb': {
  //     domainScript: '55bc6599-82ca-4c1b-a384-c955feab9ea5',
  //   },
  //   de: {
  //     domainScript: '4ea18404-90d8-4864-8153-459b9dcc47aa',
  //   },
  //   ko: {
  //     domainScript: '11a5c22e-ed4a-45cd-8e78-2286cd7bc644',
  //   },
  //   asia: {
  //     domainScript: '330f1c36-f361-431e-858e-c2bc93cca856',
  //   },
  //   'zh-hans': {
  //     domainScript: '08178bc7-a6dd-4a39-87c3-b48041f5fc09',
  //   },
  //   fr: {
  //     domainScript: 'bbc2df4f-0876-4bf0-b400-50589353c517',
  //   },
  //   es: {
  //     domainScript: '49da266b-47aa-40d7-8477-9e163fc24d38',
  //   },
  //   ch: {
  //     domainScript: '019541ce-769c-773d-a9f1-f69d02b737e4',
  //   },
  //   at: {
  //     domainScript: '9e902633-1b82-4fe9-90c6-45db890d5476',
  //   },
  //   se: {
  //     domainScript: 'c73b20d9-6983-49d8-a60e-04dc633ae03d',
  //   },
  //   ie: {
  //     domainScript: '4fc9a59f-7111-4160-9d86-daa96a302e3d',
  //   },
  //   be: {
  //     domainScript: '22acf6cb-6ea9-4eac-ae72-7948924d7a44',
  //   },
  //   el: {
  //     domainScript: '4689a0af-d294-4a1c-aac0-0813d63b2ca0',
  //   },
  //   dk: {
  //     domainScript: '018deb70-2289-7660-89c6-0d8e44300af1',
  //   },
  // };

  const domainScript = isStagingEnv
    ? '019b8ef6-880d-7d4f-aa9c-a69d207d2f53'
    : 'ec376bc6-9b0b-4f57-a6d8-2d6c73d285c5'; // TODO: add uat script when provided

  if (isIxnquery) {
    return null;
  }

  // const script = scriptConfig[lang];

  // if (script) {
  //   return (
  //     <Fragment>
  //       <script
  //         src={`https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`}
  //         data-document-language="true"
  //         type="text/javascript"
  //         charset="UTF-8"
  //         data-domain-script={script.domainScript}
  //         defer
  //       />
  //       <script
  //         dangerouslySetInnerHTML={{
  //           __html: `function OptanonWrapper() { }`,
  //         }}
  //       />
  //     </Fragment>
  //   );
  // }

  return (
    <Fragment>
      <script
        src={`https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`}
        type="text/javascript"
        charset="UTF-8"
        data-domain-script={domainScript}
        defer
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `function OptanonWrapper() { }`,
        }}
      />
    </Fragment>
  );
};

// `page` is the 0-based page of a paginated listing, or 0/undefined for an
// ordinary page.
//
// It matters that a paginated URL canonicalises to ITSELF. Pointing every page
// of a series at page one tells search engines that pages 2…n are duplicates
// and should be dropped — which would undo the crawlable-pagination work the
// moment it shipped. Without the parameter below that is exactly what this
// function did, because it rebuilds the URL from the alias and the alias
// carries no query string.
// Locale -> canonical host. Shared by every tag that has to spell out an
// absolute URL for this page.
const getCanonicalBase = (lang) => {
  let canonFront = '';
  switch (lang) {
    case 'en':
      canonFront = Constants.en;
      break;
    case 'de':
      canonFront = Constants.de;
      break;
    case 'fr':
      canonFront = Constants.fr;
      break;
    case 'nl':
      canonFront = Constants.nl;
      break;
    case 'en-gb':
      canonFront = Constants.uk;
      break;
    case 'at':
      canonFront = Constants.at;
      break;
    case 'zh-hans':
      canonFront = Constants.cn;
      break;
    case 'ko':
      canonFront = Constants.kr;
      break;
    case 'el':
      canonFront = Constants.gr;
      break;
    case 'ch':
      canonFront = Constants.ch;
      break;
    case 'asia':
      canonFront = Constants.asia;
      break;
    case 'ja':
      canonFront = Constants.jp;
      break;
    case 'es':
      canonFront = Constants.es;
      break;
    case 'dk':
      canonFront = Constants.dk;
      break;
    case 'se':
      canonFront = Constants.se;
      break;
    case 'be':
      canonFront = Constants.be;
      break;
    case 'ie':
      canonFront = Constants.ie;
      break;
    case 'it':
      canonFront = Constants.it;
      break;
    default:
      break;
  }
  return canonFront;
};

export const getCanonical = (canonicalUrl, lang, urlAlias, page = 0) => {
  const canonFront = getCanonicalBase(lang);
  const pageSuffix = page > 0 ? `?page=${page + 1}` : '';

  if (canonicalUrl) {
    return (
      <link rel={'canonical'} href={canonFront + canonicalUrl + pageSuffix} />
    );
  } else {
    let canUrlAlias = urlAlias;
    if (urlAlias == 'home') {
      return <link rel={'canonical'} href={canonFront + pageSuffix} />;
    }
    return (
      <link
        rel={'canonical'}
        href={canonFront + '/' + canUrlAlias + pageSuffix}
      />
    );
  }
};

/**
 * `<link rel="prev">` for page two onwards. The matching "next" signal rides on
 * the Show More anchor itself (see PaginationLink), which is the link a crawler
 * actually follows.
 *
 * Google dropped rel prev/next as an indexing signal in 2019, but Bing still
 * reads it and it costs one tag.
 */
export const getPaginationRelPrev = (lang, urlAlias, page = 0) => {
  if (!page || page < 1) {
    return null;
  }

  const canonFront = getCanonicalBase(lang);
  const base =
    urlAlias === 'home' ? canonFront : canonFront + '/' + urlAlias;
  const prev = page > 1 ? `?page=${page}` : '';

  return <link rel={'prev'} href={base + prev} />;
};

/**
 * `<meta name="robots" content="noindex, follow">` for views that exist only
 * because a visitor typed something.
 *
 * SEO's decision (2026-10-12): user search queries should not be indexable.
 * Every term produces its own URL over content that is already indexed
 * elsewhere, and pagination now makes the rest of those results reachable by
 * link too — so without this each query would be an indexable page of
 * duplicates.
 *
 * `follow` rather than `none`: the links on the page still lead to the real
 * articles and facilities, and those should keep being crawled.
 *
 * Driven by the search term alone, so it covers both the global search page
 * (`/search?search=cloud`) and a searched listing
 * (`/resources/blog?search=cloud`), on every page of either.
 *
 * Filters deliberately do not get this. They are kept out of the index by
 * canonicalising to the bare listing, which SEO reviewed and asked us to leave
 * as it is; adding `noindex` on top would be the contradictory pair Google
 * warns about — a canonical passes signals on, `noindex` throws them away.
 */
export const getSearchRobotsMeta = (query) => {
  if (!getSearchFromQuery(query)) {
    return null;
  }

  return <meta name="robots" content="noindex, follow" />;
};

export const getDomainAlias = (lang) => {
  const langMap = {
    en: 'en',
    'en-gb': 'uk',
    fr: 'fr',
    de: 'de',
    nl: 'nl',
    cn: 'zh-hans',
    kr: 'ko',
    asia: 'asia',
    es: 'es',
    at: 'at',
    ch: 'ch',
    se: 'se',
    dk: 'dk',
    ie: 'ie',
    hr: 'hr',
    be: 'be',
    gr: 'el',
    it: 'it',
  };

  return langMap[lang] || 'en';
};

export const getLanguageContent = (lang) => {
  switch (lang) {
    case 'asia':
    case 'ie':
    case 'se':
    case 'dk':
    case 'nl':
    case 'be':
    case 'el':
      return 'en';
    case 'ch':
    case 'at':
      return 'de';
    default:
      return lang;
  }
};

export const renderAlternateLinks = (languages, Constants) => {
  if (!Array.isArray(languages)) {
    console.error('Expected languages to be an array but got:', languages);
    return null;
  }
  const existOnMainSite = languages.some(
    (lang) => Object.keys(lang)[0] === 'en'
  );
  const enLang = languages.find((lang) => lang.hasOwnProperty('en'));
  return (
    <>
      {existOnMainSite ? (
        enLang['en'] == '/home' ? (
          <link href={`${Constants.en}`} rel="alternate" hrefLang="x-default" />
        ) : (
          <link
            href={`${Constants.en}${enLang['en']}`}
            rel="alternate"
            hrefLang="x-default"
          />
        )
      ) : (
        <link href={Constants.en} rel="alternate" hrefLang="x-default" />
      )}
      {languages.map((lang) => {
        const langCode = Object.keys(lang)[0];
        const urlAlias = lang[langCode].replace(/^\/\//, '/'); // Remove double slashes
        switch (langCode) {
          case 'en':
            return (
              <link
                key="alternate-en"
                href={
                  urlAlias === '/home' ? Constants.en : Constants.en + urlAlias
                }
                rel="alternate"
                // hreflang={'en-US'}
                hreflang={'en'}
              />
            );
          case 'de':
            return (
              <link
                key="alternate-de"
                href={
                  urlAlias === '/home' ? Constants.de : Constants.de + urlAlias
                }
                rel="alternate"
                // hreflang={'de-DE'}
                hreflang={'de'}
              />
            );
          case 'fr':
            return (
              <link
                key="alternate-fr"
                href={
                  urlAlias === '/home' ? Constants.fr : Constants.fr + urlAlias
                }
                rel="alternate"
                // hreflang={'fr-FR'}
                hreflang={'fr'}
              />
            );
          case 'es':
            return (
              <link
                key="alternate-es"
                href={
                  urlAlias === '/home' ? Constants.es : Constants.es + urlAlias
                }
                rel="alternate"
                // hreflang={'es-ES'}
                hreflang={'es'}
              />
            );
          case 'ko':
            return (
              <link
                key="alternate-ko"
                href={
                  urlAlias === '/home' ? Constants.kr : Constants.kr + urlAlias
                }
                rel="alternate"
                // hreflang={'ko-KR'}
                hreflang={'ko'}
              />
            );
          case 'zh-hans':
            return (
              <link
                key="alternate-zh-hans"
                href={
                  urlAlias === '/home' ? Constants.cn : Constants.cn + urlAlias
                }
                rel="alternate"
                // hreflang={'zh-CN'}
                hreflang={'zh-hans'}
              />
            );
          case 'it':
            return (
              <link
                key="alternate-it"
                href={
                  urlAlias === '/home' ? Constants.it : Constants.it + urlAlias
                }
                rel="alternate"
                hreflang={'it'}
              />
            );
        }
      })}
    </>
  );
};

export const onScroll = () => {
  const html = document.querySelector('html');
  const thumb = document.querySelector('.overlay-scrollbar-thumb');
  // Calculate the percentage of the container that is scrolled

  let scrollPercentage =
    (html.scrollTop / (html.scrollHeight - html.clientHeight)) * 100;

  if (Math.sign(scrollPercentage) === -1) {
    scrollPercentage = 0;
  }

  if (thumb) {
    thumb.style.top = `${scrollPercentage}vh`;
  }
};

export function checkIsImage(items) {
  if (!items.length) return false;
  let ogImageIsSet = false;
  items.map((e) => {
    if (e && e[0] == 'og:image') {
      ogImageIsSet = true;
    }
  });
  return ogImageIsSet;
}

export const getLandPageFromRedirect = (lang, device, ixnRedirectMessages) => {
  if (!lang) return;

  if (lang === 'en-gb') {
    lang = 'uk';
  }

  const messages = ixnRedirectMessages[lang];

  return (
    <main>
      <div className="graybg-redirect"></div>
      <img
        src={`/images/interxion-${lang}-${device}.png`}
        className={`interxion-site image-${lang}`}
      />
      <div id="redirect-popup">
        <div id="first-row">
          <div>
            <img
              src="https://cms-digitalrealty.azureedge.net/sites/default/files/2023-04/Digital_Realty_TM_Brandmark_RGB_White_wthtqz_0.png"
              alt="Digital Realty Brandmark"
            />
          </div>
        </div>
        <div id="second-row">
          <h2>{messages?.[0]}</h2>
          <h5>{messages?.[1]}</h5>
        </div>
        <div id="third-row">
          <span
            onClick={() => {
              removeQueryParams();
              setisIxnQuery(false);
            }}
          >
            {messages?.[2]} &#8594;
          </span>
        </div>
      </div>
    </main>
  );
};

export const removeQueryParams = () => {
  const pathname = router.pathname;
  router.push(pathname);
};

export const getDevice = (viewportWidth) => {
  if (viewportWidth < 576) {
    return 'mobile';
  } else if (viewportWidth > 576 && viewportWidth < 1025) {
    return 'tablet';
  } else if (viewportWidth > 1025 && viewportWidth < 1920) {
    return 'desktop';
  } else {
    return 'xxl';
  }
};

export const setOperatingSystemClass = () => {
  if (typeof window !== 'undefined') {
    const userAgent = window.navigator.userAgent;
    let OSName = 'Unknown OS';

    if (typeof navigator !== 'undefined') {
      if (userAgent.indexOf('Win') !== -1) OSName = 'Windows';
      if (userAgent.indexOf('Mac') !== -1) OSName = 'MacOS';
      if (userAgent.indexOf('X11') !== -1) OSName = 'UNIX';
      if (userAgent.indexOf('Linux') !== -1) OSName = 'Linux';

      if (typeof document !== 'undefined') {
        document.getElementsByTagName('body')[0].classList.add(OSName.trim());
      }
    }
  }
};
